import { render } from "./MainThreeColumns.vue?vue&type=template&id=ec742c56&ts=true"
import script from "./MainThreeColumns.vue?vue&type=script&lang=ts"
export * from "./MainThreeColumns.vue?vue&type=script&lang=ts"

import "./MainThreeColumns.vue?vue&type=style&index=0&id=ec742c56&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__